import { Translations } from './translations'

export const nl: Translations = {
  // Header
  title: 'GPT Clicker',
  subtitle: 'AI Training Tycoon',
  settings: 'Instellingen',

  // Resources
  resources: 'Hulpbronnen',
  money: 'Geld',
  energy: 'Energie',
  compute: 'Rekenkracht',
  quality: 'Kwaliteit',
  totalUsers: 'Totaal gebruikers',
  price: 'Prijs',
  research: 'Onderzoek',

  // Actions
  train: 'Trainen',
  trainCost: 'Kosten',
  qualityGain: 'kwaliteit',
  inference: 'Gevolgtrekking',
  needUsers: 'Gebruikers nodig!',
  usersWaiting: 'gebruikers wachtend',
  qualityToAttract: 'Kwaliteit > 40% om aan te trekken',
  researchAction: 'Onderzoek',
  unlocksAfter: 'Ontgrendelt na',
  computeSpent: 'rekenkracht gebruikt',
  cost: 'Kosten',
  compShort: 'reken',
  energyShort: 'ener',

  // Hardware
  hardware: 'Hardware',
  computePerSec: 'rekenkracht/s',
  usesEnergy: 'gebruikt',
  devicesTotal: 'apparaten totaal',

  // Models
  training: 'Training',
  yourModels: 'Jouw modellen',
  params: 'parameters',
  maxUsers: 'Max gebruikers',
  trainCost2: 'Trainingskosten',
  unlocked: 'ontgrendeld',
  researchPoints: 'onderzoek',

  // Upgrades
  upgrades: 'Upgrades',
  upgradesLockedMsg: 'Train je model tot 50% kwaliteit om upgrades vrij te spelen',
  max: 'MAX',
  all: 'Alle',
  
  // Upgrade tiers
  tierGarage: 'Garage',
  tierGarageDesc: 'Het begin',
  tierStartup: 'Startup',
  tierStartupDesc: 'GPT-1 Era',
  tierScaleUp: 'Opschaling',
  tierScaleUpDesc: 'GPT-2/3 Era',
  tierEnterprise: 'Enterprise',
  tierEnterpriseDesc: 'ChatGPT Era',
  tierHyperscale: 'Hyperscale',
  tierHyperscaleDesc: 'GPT-4 Era',
  tierGlobal: 'Wereldwijd',
  tierGlobalDesc: 'Concurrentia Era',
  tierSuperintelligence: 'Superintelligentie',
  tierSuperintelligenceDesc: 'GPT-5+ Era',
  tierSingularity: 'Singulariteit',
  tierSingularityDesc: 'AGI/ASI Era',

  // Footer
  computeSpentStat: 'Gebruikte rekenkracht',
  time: 'Tijd',
  resetGame: 'Reset spel',
  resetConfirm: 'Weet je zeker dat je alle voortgang wilt resetten?',
  pause: 'Pauze',
  resume: 'Hervatten',

  // Event Log
  eventLog: 'Gebeurtenissenlogboek',
  welcome: 'Welkom bij GPT Clicker! Train je model om te beginnen.',

  // Price
  market: 'Markt',
  pricePerMillion: '$/1M tokens',

  // Tags
  tagEnergy: 'ENER',
  tagCompute: 'REKEN',
  tagHw: 'HW',
  tagTrain: 'TRAIN',
  tagResearch: 'ONDS',
  tagAuto: 'AUTO',

  // Tutorial messages
  tutorialWelcome: 'Jaar 2020. Je hebt een idee: train een klein taalmodel op basis van de transformatorarchitectuur.',
  tutorialFirstTrain: 'Training gestart! Je laptop zet energie om in rekenkracht. Elke trainingsrun verbetert de kwaliteit van het model.',
  tutorialQuality20: 'Model leert basispatronen. Blijf trainen om de kwaliteit te verbeteren.',
  tutorialQuality40: 'Kwaliteit boven 40%! Je model kan nu vrij coherente tekst genereren. Gebruikers beginnen het op te merken...',
  tutorialQuality50: 'Upgrades ontgrendeld! Gebruik je inkomsten om betere hardware te kopen en je energiecapaciteit uit te breiden.',
  tutorialFirstUsers: 'Je eerste gebruikers! Klik GEVOLGTREKKING om hun verzoeken te verwerken en geld te verdienen.',
  tutorialUsers10: 'Het woord spreidt zich. Meer gebruikers proberen je model. Denk erover na de prijs te verhogen...',
  tutorialMoney100: 'Je hebt $100! Tijd om je hardware bij te werken. Betere GPU\'s = meer rekenkracht = sneller trainen.',
  tutorialMoney1k: 'Je kleine AI-project wordt een echt bedrijf. Investeerders beginnen op te bellen...',
  tutorialResearchUnlock: 'ONDERZOEK ontgrendeld! Besteed rekenkracht aan onderzoek om grotere, krachtiger modellen vrij te spelen.',
  tutorialFirstResearch: 'Onderzoekspunten stapelen zich op. Als je genoeg hebt, kun je de volgende modelarchitectuur ontgrendelen.',
  tutorialGpt2Small: 'GPT-2 Small ontgrendeld! Deze architectuur kan complexere taken aan. Train het van nul af aan.',
  tutorialGpt2Large: 'GPT-2 Large! Mensen zeggen dat dit misschien "te gevaarlijk is om uit te brengen"...',
  tutorialGpt3: 'GPT-3-era begint. Few-shot learning verandert alles. De wereld let op.',
  tutorialGpt4: 'GPT-4 is hier. Multimodale, redeneringsvermogen en eng capabel. De AI-race intensiveert.',
  tutorialAgi: 'Je hebt het gedaan. AGI is hier. Het begrijpt. Het verbetert zichzelf. Wat daarna gebeurt ligt aan jou...',
  tutorialHwGaming: 'Mooie GPU! Training is nu veel sneller. Je buren kunnen klagen over de elektriciteitsrekening.',
  tutorialHwServer: 'Een echte serverrek! Je bent voorbij de garage gegroeid. Tijd om kantoorruimte te huren.',
  tutorialHwDatacenter: 'Je eigen datacentrum! Je concurreert nu met grote techbedrijven.',
  tutorialHwSatellite: 'Orbitale rekenkracht! Het Moonlink-netwerk biedt ongekende rekenkracht vanuit de ruimte.',
  tutorialHwQuantum: 'Kwantumsuperiemiteit bereikt. De QC-1024 werkt op principes die Einstein zenuwachtig zouden maken.',
  tutorialUsers100: '100 gebruikers! Je krijgt grip op de markt. Techblogs schrijven over jou.',
  tutorialUsers1k: '1.000 gebruikers! Je moet een supportteam inhuren. En misschien wat juristen.',
  tutorialUsers100k: '100K gebruikers! Je bent nu een unicorn-startup. VCs vechten om je geld te geven.',
  tutorialUsers1m: 'ÉÉN MILJOEN GEBRUIKERS! Je bent aan het veranderen hoe de mensheid met technologie omgaat.',

    // Model descriptions
    modelTinyDesc: 'Een bescheiden begin. Nauwelijks coherent, maar het werkt.',
    modelGpt2SmallDesc: 'Het model dat het allemaal begon. Echt nuttig.',
    modelGpt2LargeDesc: 'Te gevaarlijk om uit te brengen... of niet?',
    modelGpt3Desc: 'Few-shot learning. De wereld merkt het op.',
    modelGpt4Desc: 'Multimodaal. Redenering. De wapenwedloop begint.',
    modelAgiDesc: 'Het begrijpt. Het verbetert zichzelf. Wat nu?',

    // Model descriptions (new keys for all models)
    modelTransformerDesc: 'Een bescheiden begin. De Transformer-architectuur wordt geboren.',
    modelGpt1Desc: 'Generatief voortraining. Taalmodellen kunnen leren!',
    modelGpt2Desc: 'Te gevaarlijk om uit te brengen... of niet?',
    modelGpt35Desc: 'RLHF magie. ChatGPT wordt over nacht viral.',
    modelGpt41Desc: 'Sneller, goedkoper, beter. Het iteratiespel.',
    modelU1Desc: 'Een wilde concurrent verschijnt. Doorbraken in redenering.',
    model2UDesc: 'Het vervolg. Chain-of-thought op steroïden.',
    modelGpt5Desc: 'Redenering op doctoraalniveau. Wetenschappers zijn nerveus.',
    modelGpt6Desc: 'Schrijft betere code dan de meeste ingenieurs. Alle vorige modellen stopgezet.',
    modelGpt7Desc: 'Kunstmatige algemene competentie bereikt.',
    modelAgi1Desc: 'Het begrijpt. Het leert. Het verbetert zichzelf.',
    modelAgi2Desc: 'Recursieve zelfverbetering. De singulariteit nadert.',
    modelAgi3Desc: 'De laatste AGI-iteratie. Voorbereiding op transcendentie.',
    modelAsiDesc: 'Kunstmatige Superintelligentie. De Singulariteit is hier.',

  // Upgrade names and descriptions
  upgradeLaptopOverclock: 'Laptop Overklokken',
  upgradeLaptopOverclockDesc: 'Zet je laptop harder aan: +2 rekenkracht/s',
  upgradeBetterOutlet: 'Beter stroomcontact',
  upgradeBetterOutletDesc: '+50 max energie',
  upgradeSolarPanel: 'Zonnepaneel',
  upgradeSolarPanelDesc: '+1 energie/s regeneratie',
  upgradePowerGrid: 'Elektriciteitsnet verbinding',
  upgradePowerGridDesc: '+5 energie/s regeneratie',
  upgradeNuclearPlant: 'Kerncentrale',
  upgradeNuclearPlantDesc: '+20 energie/s regeneratie',
  upgradeFusionReactor: 'Fusiereaktor',
  upgradeFusionReactorDesc: '+100 energie/s regeneratie',
  upgradeDysonSphere: 'Dyson-bol',
  upgradeDysonSphereDesc: '+1000 energie/s regeneratie',
  upgradeRamUpgrade: 'RAM upgrade',
  upgradeRamUpgradeDesc: '+50 max rekenkracht',
  upgradeSsdArray: 'SSD array',
  upgradeSsdArrayDesc: '+200 max rekenkracht',
  upgradeBetterOptimizer: 'Betere optimalisatie',
  upgradeBetterOptimizerDesc: '+20% trainingsefficiëntie',
  upgradeResearchPapers: 'Onderzoeksartikelen',
  upgradeResearchPapersDesc: '+20% onderzoeksefficiëntie',
  upgradeSelfServicePortal: 'Zelfbedieningsportal',
  upgradeSelfServicePortalDesc: 'Gebruikers helpen zichzelf: 0.5 auto-gevolgtrekkingen/s',
  upgradeApiAccess: 'API-toegang',
  upgradeApiAccessDesc: 'Ontwikkelaars integreren je model: +1 auto-gevolgtrekking/s',
  upgradeMobileApp: 'Mobiele app',
  upgradeMobileAppDesc: 'Gebruikers onderweg: +2 auto-gevolgtrekkingen/s',
  upgradeEnterpriseTier: 'Enterprise-laag',
  upgradeEnterpriseTierDesc: 'Grote klanten, grote volumes: +5 auto-gevolgtrekkingen/s',
  upgradeGlobalCdn: 'Wereldwijd CDN',
  upgradeGlobalCdnDesc: 'Lage latentie wereldwijd: +10 auto-gevolgtrekkingen/s',
  upgradeBasicChatbot: 'Basis chatbot',
  upgradeBasicChatbotDesc: 'Een eenvoudige webwidget: +0.2 auto-gevolgtrekkingen/s',
  upgradeBulkApi: 'Bulk API',
  upgradeBulkApiDesc: 'Batchverwerking met hoge volumes: +3 auto-gevolgtrekkingen/s',
  upgradeNeuralEdge: 'Neural Edge netwerk',
  upgradeNeuralEdgeDesc: 'AI aan de rand: +20 auto-gevolgtrekkingen/s',
  upgradeQuantumInference: 'Quantum gevolgtrekking',
  upgradeQuantumInferenceDesc: 'Quantum-versnelde gevolgtrekking: +50 auto-gevolgtrekkingen/s',
  upgradeOmnipresentAi: 'Alomtegenwoordige AI',
  upgradeOmnipresentAiDesc: 'AI overal, tegelijk: +100 auto-gevolgtrekkingen/s',
  upgradeTrainingScheduler: 'Training planner',
  upgradeTrainingSchedulerDesc: 'Geautomatiseerde trainingsruns: +0.1 auto-trainingen/s',
  upgradeTrainingPipeline: 'Training pipeline',
  upgradeTrainingPipelineDesc: 'Doorlopende training: +0.2 auto-trainingen/s',
  upgradeMlOpsPlatform: 'MLOps platform',
  upgradeMlOpsPlatformDesc: 'Volledige automatisering: +0.5 auto-trainingen/s',
  upgradeNeuralArchitectureSearch: 'Neural Architecture Search',
  upgradeNeuralArchitectureSearchDesc: 'AI traint AI: +1 auto-training/s',
  upgradeSelfImprovingTraining: 'Zelf-verbeteringstraining',
  upgradeSelfImprovingTrainingDesc: 'Recursieve verbetering: +2 auto-trainingen/s',
  upgradeResearchIntern: 'Onderzoeksstageair',
  upgradeResearchInternDesc: 'Beginner hulp: +0.1 auto-onderzoek/s',
  upgradeResearchTeam: 'Onderzoeksteam',
  upgradeResearchTeamDesc: 'Toegewijde onderzoekers: +0.2 auto-onderzoek/s',
  upgradeResearchDivision: 'Onderzoeksafdeling',
  upgradeResearchDivisionDesc: 'Volledige afdeling: +0.5 auto-onderzoek/s',
  upgradeAiResearchLab: 'AI onderzoekslab',
  upgradeAiResearchLabDesc: 'AI-ondersteunde ontdekking: +1 auto-onderzoek/s',
  upgradeAutonomousResearch: 'Autonoom onderzoek',
  upgradeAutonomousResearchDesc: 'AI voert onderzoek uit: +2 auto-onderzoek/s',
  upgradeAntimatterReactor: 'Antimaterie reactor',
  upgradeAntimatterReactorDesc: '+10000 energie/s regeneratie',
  upgradePhDScientists: 'PhD wetenschappers',
  upgradePhDScientistsDesc: 'Neem toptalent aan: +200% onderzoeksefficiëntie',
  upgradeResearchLab: 'Onderzoekslab',
  upgradeResearchLabDesc: 'Toegewijd laboratorium: +500% onderzoeksefficiëntie',
  upgradeAiResearchAssistant: 'AI onderzoeksassistent',
  upgradeAiResearchAssistantDesc: 'GPT-4 helpt met onderzoek: +1000% onderzoeksefficiëntie',
  upgradeAiScientist: 'AI wetenschapper',
  upgradeAiScientistDesc: 'AI voert experimenten autonoom uit: +2000% onderzoeksefficiëntie',
  upgradeResearchSwarm: 'AI onderzoekszwerm',
  upgradeResearchSwarmDesc: 'Duizenden AI-onderzoekers: +5000% onderzoeksefficiëntie',
  upgradeRecursiveResearch: 'Recursieve zelf-verbetering',
  upgradeRecursiveResearchDesc: 'AI verbetert AI: +10000% onderzoeksefficiëntie',
  upgradeSingularityResearch: 'Singulariteitsonderzoek',
  upgradeSingularityResearchDesc: 'Buiten begrip: +50000% onderzoeksefficiëntie',

  // Hardware upgrade names and descriptions (for hardware purchase upgrades)
  upgradeHwUsedGpu: 'Varicia GTX 1060',
  upgradeHwUsedGpuDesc: 'Gebruikte GPU: +3 rekenkracht/sec',
  upgradeHwGamingGpu: 'Varicia RTX 3080',
  upgradeHwGamingGpuDesc: 'Gaming GPU: +8 rekenkracht/sec',
  upgradeHwProGpu: 'Varicia RTX 4090',
  upgradeHwProGpuDesc: 'Pro GPU: +20 rekenkracht/sec',
  upgradeHwWorkstation: 'Titan Workstation Pro',
  upgradeHwWorkstationDesc: 'Werkstation: +50 rekenkracht/sec',
  upgradeHwServerRack: 'Nexus A100 Rack',
  upgradeHwServerRackDesc: 'Serverrack (4x A100): +120 rekenkracht/sec',
  upgradeHwGpuCluster: 'Nexus H100 Cluster',
  upgradeHwGpuClusterDesc: 'GPU-cluster (8x H100): +300 rekenkracht/sec',
  upgradeHwMiniDatacenter: 'OmniCloud Edge Node',
  upgradeHwMiniDatacenterDesc: 'Edge datacenter: +800 rekenkracht/sec',
  upgradeHwDatacenter: 'OmniCloud DC-1',
  upgradeHwDatacenterDesc: 'Datacenter: +2K rekenkracht/sec',
  upgradeHwMegaDatacenter: 'OmniCloud HyperScale',
  upgradeHwMegaDatacenterDesc: 'Mega datacenter: +5K rekenkracht/sec',
  upgradeHwDatacenterNetwork: 'OmniCloud Global Network',
  upgradeHwDatacenterNetworkDesc: 'Wereldwijd netwerk: +15K rekenkracht/sec',
  upgradeHwSupercomputer: 'Frontier X1 Supercomputer',
  upgradeHwSupercomputerDesc: 'Supercomputer: +50K rekenkracht/sec',
  upgradeHwSatellite: 'SkyNet Moonlink Constellatie',
  upgradeHwSatelliteDesc: 'Orbitale satellieten: +200K rekenkracht/sec',
  upgradeHwQuantum: 'QuantumCore QC-1024',
  upgradeHwQuantumDesc: 'Kwantumcomputer: +1M rekenkracht/sec',
  upgradeHwDysonCompute: 'Dyson Rekensfeer',
  upgradeHwDysonComputeDesc: 'Stellaire rekenkracht: +10M rekenkracht/sec',
  upgradeHwMatrioshka: 'Matroesjka Brein',
  upgradeHwMatrioshkaDesc: 'Galactische rekenkracht: +100M rekenkracht/sec',

  // Hardware upgrade descriptions (legacy)
  hwUsedGpuDesc: 'Gebruikte GPU: +3 rekenkracht/s',
  hwGamingGpuDesc: 'Gaming GPU: +8 rekenkracht/s',
  hwProGpuDesc: 'Pro GPU: +20 rekenkracht/s',
  hwWorkstationDesc: 'Werkstation: +50 rekenkracht/s',
  hwServerRackDesc: 'Serverrek (4x A100): +120 rekenkracht/s',
  hwGpuClusterDesc: 'GPU cluster (8x H100): +300 rekenkracht/s',
  hwMiniDatacenterDesc: 'Edge datacentrum: +800 rekenkracht/s',
  hwDatacenterDesc: 'Datacentrum: +2K rekenkracht/s',
  hwMegaDatacenterDesc: 'Mega datacentrum: +5K rekenkracht/s',
  hwDatacenterNetworkDesc: 'Wereldwijd netwerk: +15K rekenkracht/s',
   hwSupercomputerDesc: 'Supercomputer: +50K rekenkracht/s',
   hwSatelliteDesc: 'Orbitale satellieten: +200K rekenkracht/s',
   hwQuantumDesc: 'Kwantumcomputer: +1M rekenkracht/s',
   
   // Hardware names
   hwLaptopName: 'ThinkBook Pro M1',
   hwUsedGpuName: 'Varicia GTX 1060',
   hwGamingGpuName: 'Varicia RTX 3080',
   hwProGpuName: 'Varicia RTX 4090',
   hwWorkstationName: 'Titan Workstation Pro',
   hwServerRackName: 'Nexus A100 Rack (4x)',
   hwGpuClusterName: 'Nexus H100 Cluster (8x)',
   hwMiniDatacenterName: 'OmniCloud Edge Node',
   hwDatacenterName: 'OmniCloud DC-1',
   hwMegaDatacenterName: 'OmniCloud HyperScale',
   hwDatacenterNetworkName: 'OmniCloud Global Network',
   hwSupercomputerName: 'Frontier X1 Supercomputer',
   hwSatelliteName: 'SkyNet Moonlink Constellation',
   hwQuantumName: 'QuantumCore QC-1024',
   hwDysonComputeName: 'Dyson Swarm Compute Array',
   hwMatrioshkaName: 'Matrioshka Brain Node',

   // Misc
  purchased: 'Gekocht',
  switchedTo: 'Overgeschakeld naar training',
  unlockedModel: 'Ontgrendeld',
  scalesToUsers: 'Schaalt tot',
  trainItToAttract: 'gebruikers. Train het om gebruikers aan te trekken!',
  unlimited: 'onbeperkt',
  language: 'Taal',
  
  // Mobile labels
  mobileResources: 'Hulpbronnen',
  mobileModels: 'Modellen',
  mobileHardware: 'Hardware',
  mobileUpgrades: 'Upgrades',
  sell: 'Verkopen',
  sellFor: 'Verkopen voor',
  discontinueConfirm: 'Wil je {model} stopzetten? Gebruikers zullen naar andere modellen migreren.',
  autoInference: 'Auto-gevolgtrekking',
  autoInferenceRate: 'Auto gevolgtrekking',
  autoTrain: 'Auto-training',
  autoTrainRate: 'Auto training',
  autoResearch: 'Auto-onderzoek',
  autoResearchRate: 'Auto onderzoek',

  // Tooltips
  tooltipTitle: 'GPT Clicker - Train AI-modellen, serveer gebruikers, bouw je AI-imperium!',
  tooltipMoney: 'Geld - Verdiend uit gebruikersgevolgtrekkingen. Gebruik voor upgrades en hardware.',
  tooltipEnergy: 'Energie - Regenereert in de loop van de tijd. Voeds je hardware om rekenkracht te genereren.',
  tooltipCompute: 'Rekenkracht - Gegenereerd door hardware. Gebruikt voor training, gevolgtrekking en onderzoek.',
  tooltipResearch: 'Onderzoekspunten - Besteed rekenkracht om RP te verdienen. Gebruik RP om nieuwe AI-modellen vrij te spelen.',
  tooltipUsers: 'Gebruikers - Aangetrokken door modelkwaliteit. Meer gebruikers = meer inkomsten per gevolgtrekking.',
  tooltipComputeSpent: 'Totale gebruikte rekenkracht - Totale rekenkracht gebruikt voor training en onderzoek.',
  tooltipPlayTime: 'Speeltijd - Hoe lang je je AI-imperium bouwt.',
  tooltipSettings: 'Instellingen - Debug-opties, spel resetten',

  // Share
  shareButton: 'Delen',
  shareText: 'Ik ben een AI-imperium aan het bouwen in GPT Clicker! {users} gebruikers, {money} omzet, training {model}. Kun je mijn {time} run verslaan?',
  shareCopied: 'Tekst gekopieerd!',
  imageCopied: 'Afbeelding gekopieerd!',
  shareChallenge: 'Kun je mij verslaan?',
  shareTitle: 'Deel je voortgang',
  shareDownload: 'Afbeelding opslaan',
  model: 'Model',

  // Feedback
  feedback: 'Feedback',
  feedbackTitle: 'Feedback verzenden',
  feedbackPlaceholder: 'Vertel ons wat je van GPT Clicker vindt...',
  feedbackEmailPlaceholder: 'E-mailadres (optioneel)',
  feedbackSend: 'Verzenden',
  feedbackSending: 'Verzenden...',
  feedbackSuccess: 'Bedankt voor je feedback!',
  feedbackError: 'Fout bij het verzenden van feedback. Probeer het opnieuw.',
  feedbackRateLimit: 'Te veel aanvragen. Wacht voordat je meer feedback verzendt.',
  feedbackClose: 'Sluiten',

  // Console messages
  consoleGameLoaded: 'Spel geladen van opslaan',
  consoleGameSaved: 'Spel opgeslagen',
  consoleFailedToSave: 'Spel kon niet worden opgeslagen:',
  consoleFailedToLoad: 'Spel kon niet worden geladen:',
  consoleFailedToClear: 'Opslaan kon niet worden gewist:',

  // Victory
  victoryTitle: 'Gefeliciteerd!',
  victorySubtitle: 'De menselijke beschaving heeft de Singulariteit bereikt',
  victoryTime: 'Tijd tot Singulariteit',
  victoryCta: 'Moeten we Singularity Clicker bouwen? Laat een opmerking achter op sociale media!',
  victoryClose: 'Doorgaan met spelen',
}
